import { config } from '../config/environment.js';

const LOG_LEVELS = { error: 0, warn: 1, info: 2, debug: 3, trace: 4 };

const resolveLevel = () => {
	if (typeof window !== 'undefined' && window.__WINBIT_LOG_LEVEL) {
		return LOG_LEVELS[window.__WINBIT_LOG_LEVEL] ?? LOG_LEVELS.info;
	}
	const cfgLevel = config?.app?.logLevel || 'info';
	return LOG_LEVELS[cfgLevel] ?? LOG_LEVELS.info;
};

const noop = () => {};

const createLogger = (prefix) => {
	const fmt = prefix ? `[${prefix}]` : '';

	const shouldLog = (level) => resolveLevel() >= LOG_LEVELS[level];

	return {
		error: (...args) => shouldLog('error') && console.error(fmt, ...args),
		warn:  (...args) => shouldLog('warn')  && console.warn(fmt, ...args),
		info:  (...args) => shouldLog('info')  && console.log(fmt, ...args),
		debug: (...args) => shouldLog('debug') && console.debug(fmt, ...args),
		trace: (...args) => shouldLog('trace') && console.debug(fmt, ...args),
	};
};

const defaultLogger = createLogger('');

export const logger = defaultLogger;
export { createLogger };
export default defaultLogger;
